import * as actionTypes from '../aciton-mgr/actionTypes';
import { createActionObject, getNoArgDispatcherFunc } from '../../helpers/common';

export const setMessage = message => dispatch => dispatch(
  createActionObject(
    actionTypes.SET_MESSAGE,
    { message }
  )
);

export const toggleMessageDialog = getNoArgDispatcherFunc(actionTypes.TOGGLE_REPORT_DIALOG);

export const closeSnackBar = getNoArgDispatcherFunc(actionTypes.CLOSE_SNACK_BAR);